import StateManager from './StateManager';
import $ from 'jquery';
import Q from 'q';
import _ from 'underscore';

/* --------------------------------------------------

    LAYOUT

-------------------------------------------------- */

var MobileLayout = function() {
    // :)
};

$.extend(MobileLayout.prototype, {

    name: 'MobileLayout',

    bodyClass: 's-mobile',

    isAvailable: function() {
        return $(window).width() <= 700;
    },

    activate: function() {
        this.mhead = new Mead();
        this.pages = new Pages();

        var self = this;
        return Q.fcall(function(){
          self.mhead.activate();
          self.pages.activate();
        });
    },

    deactivate: function() {
        this.mhead.deactivate();
        this.pages.deactivate();

        var self = this;
        return Q.fcall(function(){
          self.mhead = null;
          self.pages = null;
        });
    },

});


/* --------------------------------------------------

    MEAD (mobile head)

-------------------------------------------------- */

var MHEAD_TEMPLATE =
    '<div class="c-scuba-layout__mhead">'+
        '<a href="#" class="c-scuba-layout__mhead__back js-scuba__mhead__back"></a>'+
        '<a href="#" class="c-scuba-layout__mhead__icon js-scuba__mhead__icon"></a>'+
        '<a href="#" class="c-scuba-layout__mhead__logo js-scuba__mhead__logo"></a>'+
        '<a href="#" class="c-scuba-layout__mhead__toggle js-scuba__mhead__toggle"></a>'+
    '</div>';

var $mhead = $("[data-mhead-template]").first();
if($mhead.length){
  MHEAD_TEMPLATE = $mhead.html();
}

var Mead = function() {};

$.extend(Mead.prototype, {

    isOpened: false,

    currentState: [],

    activate: function() {
        this.$window = $(window);
        this.$body = $(document.body);
        this.$head = $('.js-scuba__head');
        this.$headLogo = this.$head.find('.js-scuba-layout__mhead__logo a');
        this.$menu = this.$head.find('.js-scuba__menu');
        this.menu = this.$menu.data('ScubaMenuController');
        this.$main = $('.js-scuba__main');

        // éléménts dom
        this.$mhead = $(MHEAD_TEMPLATE);
        this.$mhead.find('.logo').text(this.$headLogo.text());
        this.$mhead.prependTo(this.$body);

        // écouteurs
        this.$mhead.find('.js-scuba__mhead__back').on('click', $.proxy(this._backClickHandler, this));
        this.$mhead.find('.js-scuba__mhead__icon').on('click', $.proxy(this._iconClickHandler, this));
        this.$mhead.find('.js-scuba__mhead__logo').on('click', $.proxy(this._logoClickHandler, this));
        this.$mhead.find('.js-scuba__mhead__toggle').on('click', $.proxy(this._toggleClickHandler, this));
        this.$window.on('scuba:stateChange', $.proxy(this._stateChangeHandler, this));
        this.$menu.on('submenuOpened submenuClosed', $.proxy(this._menuChangeHandler, this));
        this.$main.on('click', $.proxy(this.main_clickHandler, this));

        // init
        this._stateChangeHandler(null, StateManager.getCurrentState(true));
    },

    deactivate: function() {
        // éléments dom
        this.$mhead.remove();

        // écouteurs
        this.$main.off('click', $.proxy(this.main_clickHandler, this));
        this.$menu.off('submenuOpened submenuClosed', $.proxy(this._menuChangeHandler, this));
        this.$window.off('scuba:stateChange', $.proxy(this._stateChangeHandler, this));
    },

    closeMenu: function() {
        if (!this.isOpened) return;

        // fermeture des menus
        this.menu.closeAll();
        this.menu.setWalkingMode(false);

        this.isOpened = false;
        this.invalidate();
    },

    openMenu: function(atContext/*= true*/) {
        if (atContext !== false) atContext = true;

        if (this.isOpened) return;

        // ouverture des menus contextuels
        if (atContext) this.menu.openCurrentState();

        this.isOpened = true;
        this.invalidate();
    },

    toggleMenu: function(atContext) {
        this.isOpened ? this.closeMenu() : this.openMenu(atContext);
    },

    invalidate: function() {
        // affiche/masque le menu
        this.$body.toggleClass('mobile-menu-opened', this.isOpened);

        // doit-on afficher le bouton retour
        var hasBack = false;

        // lorsque le menu est ouvert...
        if (this.isOpened) {
            // ... et qu'on est pas au premier niveau.
            hasBack = this.menu.$sections.length > 0;
        }
        // sinon, lorsqu'on qu'il y a plusieurs pages affichées.
        else if (this.currentState.length > 1) {
            hasBack = true;
        }
        // sinon, si la première page contient un menu...
        else if (this.pageMenu) {
            // ... qu'il n'est pas à sa racine.
            hasBack = this.pageMenu.$sections.length > 0;
        }

        this.$mhead.toggleClass('has-back', hasBack);
    },

    _stateChangeHandler: function(event, state) {
        this.currentState = state;

        if (this.$pageMenu) {
            this.$pageMenu.off('submenuOpened submenuClosed', $.proxy(this._pageMenuChangeHandler, this));
        }

        this.$pageMenu = this.pageMenu = null;
        var currentPage = $(this.currentState).get(-1);
        if (currentPage) {
            this.$pageMenu = currentPage.$element.find('.js-scuba__menu');
            this.pageMenu = this.$pageMenu.data('ScubaMenuController');
            this.$pageMenu.on('submenuOpened submenuClosed', $.proxy(this._pageMenuChangeHandler, this));
        }

        // fermeture du menu ou mise à jour du bouton back
        this.isOpened ? this.closeMenu() : this.invalidate();
    },

    _menuChangeHandler: function(/*event*/) {
        if (this.isOpened) this.invalidate();

        this.$head.scrollTop(0);
    },

    _pageMenuChangeHandler: function(/*event*/) {
        $('html, body').scrollTop(0);
        if (!this.isOpened) this.invalidate();
    },

    _iconClickHandler: function(event) {
        event.preventDefault();
        event.stopPropagation();

        // if (this.isOpened) {
        //     this.$headLogo.click();
        // } else {
            this.toggleMenu(false);
        // }
    },

    _logoClickHandler: function(event) {
        event.preventDefault();
        event.stopPropagation();

        this.$headLogo.click();
    },

    _toggleClickHandler: function(event) {
        event.preventDefault();
        event.stopPropagation();

        this.toggleMenu();
        if (this.isOpened) {
            this.menu.closeAll();
        }

        // if (this.isOpened && this.menu.$sections.length > 0) {
        //     this.menu.closeLastSubmenu();
        // } else {
        //     this.toggleMenu(false);
        // }
    },

    main_clickHandler: function(event) {
        if (this.isOpened) {
            this.toggleMenu(false);
            event.preventDefault();
            event.stopPropagation();
        }
    },

    _backClickHandler: function(event) {
        event.preventDefault();
        event.stopPropagation();

        // navigation dans le menu
        if (this.isOpened) {
            this.menu.closeLastSubmenu();
            this.invalidate();
        }
        // navigation dans les pages
        else {
            // récupère la dernière page dans l'état actuel
            var state = StateManager.getCurrentState(true);
            var lastPage = state.pop();
            if (lastPage) {
                // cherche un dgt-menu à l'intérieur
                var $menu = lastPage.$element.find('.js-scuba__menu');
                if ($menu.length > 0) {
                    // récupère le controlleur associé
                    var menu = $menu.data('ScubaMenuController');
                    // tente de fermet le dernier niveau
                    if (menu.closeLastSubmenu()) return;
                }
            }

            if (this.currentState.length > 1) {
                // sinon on remonte à la page d'avant
                StateManager.popState();
            } else {
                this.openMenu(true);
            }
        }

    },

});


/* --------------------------------------------------

    PAGES

-------------------------------------------------- */

var Pages = function() {

};

$.extend(Pages.prototype, {

    currentState: null,

    currentStateIndex: -1,

    activate: function() {
        this.$window = $(window);
        this.$scroller = $('html, body');
        this.$main = $('.js-scuba__main');
        this.$head = $('.js-scuba__head');

        // écouteurs
        this.$window.on('scuba:stateChange', $.proxy(this.stateChangeHandler, this));

        // init
        this.stateChangeHandler(null, StateManager.getCurrentState(true));
    },

    deactivate: function() {
        // classes
        this.$main.find('.js-scuba__page.is-mobile-hidden').removeClass('is-mobile-hidden');

        // écouteurs
        this.$head.off('click', $.proxy(this.prevClickHandler, this));
        this.$window.off('scuba:stateChange', $.proxy(this.stateChangeHandler, this));
    },

    stateChangeHandler: function(event, state) {
        this.$scroller.scrollTop(0);

        this.currentState = state;

        if (!state || !state.length) return;

        var lastPage = state.slice(-1)[0];
        lastPage.$element.removeClass('is-mobile-hidden');

        //var page;
        _.each(state.slice(0, -1), function(page) {
            page.$element.addClass('is-mobile-hidden');
        }, this);
    },

});

export default MobileLayout;


// WEBPACK FOOTER //
// ./scripts/scuba/MobileLayout.js